// project imports
import useAuth from 'hooks/useAuth';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import config from 'config';
import { get_all_approvedMedia, mergeapprovedMedia, setSelectedapprovedMedia, set_approvedMedia } from 'features/approvedMedia/approvedMedia-slice';
import { get_all_approvedSeries, mergeapprovedSeries, setSelectedapprovedSeries, set_approvedSeries } from 'features/approvedSeries/approvedSeries-slice';
import { get_all_coherentScreen, get_selected_coherentScreen, mergecoherentScreen, setSelectedcoherentScreen, set_coherentScreen } from 'features/coherentScreen/coherentScreen-slice';
import { get_all_media, mergemedia, setSelectedmedia, set_media } from 'features/media/media-slice';
import { get_all_processedMedia, mergeprocessedMedia, setSelectedprocessedMedia, set_processedMedia } from 'features/processedMedia/processedMedia-slice';
import { get_all_series, mergeseries, setSelectedseries, set_series } from 'features/series/series-slice';
import { setAppDataStore } from 'features/firebase-app';
import { get_all_mediaCache, mergemediaCache, setSelectedmediaCache, set_mediaCache } from 'features/mediaCache/mediaCache-slice';
import { get_all_season, mergeseason, setSelectedseason, set_season } from 'features/season/season-slice';
import { get_all_curatedSeriesList, mergecuratedSeriesList, setSelectedcuratedSeriesList, set_curatedSeriesList } from 'features/curatedSeriesList/curatedSeriesList-slice';
import { get_all_releaseScheduleAction, mergereleaseScheduleAction, setSelectedreleaseScheduleAction, set_releaseScheduleAction } from 'features/releaseScheduleAction/releaseScheduleAction-slice';
import * as firebaseapp from 'features/firebase-app';
import { get_all_curatedMediaList, mergecuratedMediaList, setSelectedcuratedMediaList, set_curatedMediaList } from 'features/curatedMediaList/curatedMediaList-slice';
import { getStorage, ref, getDownloadURL, FirebaseStorage } from "firebase/storage";
import { fetch_customer_settings_for_domain, fetch_ui_cache, get_curated_media_list_for_user, get_current_coherent_screen, get_trimmed_media } from 'features/auto-thunks';
import { getUserClaims } from 'features/application/application-slice';
import { CustomerSettings, TrimmedMedia } from 'models';
import WaitingComponent from './WaitingComponent';

export default function CacheLoad(props?: any) {
    let dispatch = useDispatch();
    const { isLoggedIn } = useAuth();
    const media_list = useSelector(get_all_media);
    const series_list = useSelector(get_all_series);
    const claims = useSelector(getUserClaims);
    const curatedSeries_list = useSelector(get_all_curatedSeriesList);
    const coherentScreen_list = useSelector(get_all_coherentScreen);
    const approvedMedia_list = useSelector(get_all_approvedMedia)
    const approvedSeries_list = useSelector(get_all_approvedSeries);
    const coherentScreen = useSelector(get_selected_coherentScreen);
    const curatedMediaList_list = useSelector(get_all_curatedMediaList);
    const processedMedia_list = useSelector(get_all_processedMedia);
    const releaseScheduleAction_list = useSelector(get_all_releaseScheduleAction);
    const season_list = useSelector(get_all_season);
    const _mediaCache_list = useSelector(get_all_mediaCache);
    const [cacheLoaded, setCacheLoaded] = useState(false);
    useEffect(() => {
        if (claims?.user) {
            let hash = `${window.location.hash}`.split('#').join('')
            const searchParams = new URLSearchParams(hash);
            let info = searchParams.get('mobile');
            let redirectUrl = searchParams.get('redirectUrl');
            if (redirectUrl) {
                setAppDataStore('redirectUrl', redirectUrl);
            }
            if (info) {
                setAppDataStore('mobile', info);
            }
            else {
                setAppDataStore('mobile', null);
            }
            function handle(cacheData: any) {

                let data = cacheData || (window as any).initialState || config.code('quickLoad');
                if (data) {
                    try {
                        let quickLoad = cacheData ? (window.initialState ? window.initialState : JSON.parse(data)) : cacheData;
                        if (quickLoad?.series) {
                            if (series_list?.length)
                                dispatch(mergeseries(quickLoad?.series))
                            else {
                                dispatch(mergeseries(quickLoad?.series))
                            }
                        }
                        if (quickLoad?.seriesId) {
                            dispatch(setSelectedseries(quickLoad?.seriesId))
                        }
                        if (quickLoad?.media) {
                            if (media_list?.length)
                                dispatch(mergemedia({ data: quickLoad?.media }))
                            else {
                                dispatch(mergemedia({ data: quickLoad?.media }))
                            }
                        }
                        if (quickLoad?.mediaId) {
                            dispatch(setSelectedmedia(quickLoad?.mediaId))
                        }
                        if (quickLoad?.mediaCache) {
                            if (_mediaCache_list?.length)
                                dispatch(mergemediaCache({ data: quickLoad?.mediaCache }))
                            else {
                                dispatch(mergemediaCache({ data: quickLoad?.mediaCache }))
                            }
                        }
                        if (quickLoad?.mediaCacheId) {
                            dispatch(setSelectedmediaCache(quickLoad?.mediaId))
                        }
                        if (quickLoad?.season) {
                            if (season_list?.length) {
                                dispatch(mergeseason({ data: quickLoad?.season }))
                            }
                            else {
                                dispatch(mergeseason({ data: quickLoad?.season }))
                            }
                        }
                        if (quickLoad?.seasonId) {
                            dispatch(setSelectedseason(quickLoad?.seasonId))
                        }
                        if (quickLoad?.curatedSeriesList) {
                            if (curatedSeries_list?.length)
                                dispatch(mergecuratedSeriesList({ data: quickLoad?.curatedSeriesList }))
                            else {
                                dispatch(mergecuratedSeriesList({ data: quickLoad?.curatedSeriesList }))
                            }
                        }
                        if (quickLoad?.curatedSeriesListId) {
                            dispatch(setSelectedcuratedSeriesList(quickLoad?.curatedSeriesListId))
                        }
                        if (quickLoad?.curatedMediaList) {
                            if (curatedMediaList_list?.length) {
                                dispatch(mergecuratedMediaList({ data: quickLoad?.curatedMediaList }))
                            }
                            else {
                                dispatch(mergecuratedMediaList({ data: quickLoad?.curatedMediaList }))
                            }
                        }
                        if (quickLoad?.curatedMediaListId) {
                            dispatch(setSelectedcuratedMediaList(quickLoad?.curatedMediaListId))
                        }
                        if (quickLoad?.releaseScheduleAction) {
                            if (releaseScheduleAction_list?.length)
                                dispatch(mergereleaseScheduleAction({ data: quickLoad?.releaseScheduleAction }))
                            else {
                                dispatch(mergereleaseScheduleAction({ data: quickLoad?.releaseScheduleAction }))
                            }
                        }
                        if (quickLoad?.releaseScheduleActionId) {
                            dispatch(setSelectedreleaseScheduleAction({ data: quickLoad?.releaseScheduleActionId }))
                        }
                        if (quickLoad?.approvedMedia) {
                            if (approvedMedia_list?.length)
                                dispatch(mergeapprovedMedia({ data: quickLoad?.approvedMedia }))
                            else {
                                dispatch(mergeapprovedMedia({ data: quickLoad?.approvedMedia }))
                            }
                        }
                        if (quickLoad?.approvedMediaId) {
                            dispatch(setSelectedapprovedMedia(quickLoad?.approvedMediaId))
                        }
                        if (quickLoad?.approvedSeries) {
                            if (approvedSeries_list?.length) {
                                dispatch(mergeapprovedSeries({ data: quickLoad?.approvedSeries }))
                            }
                            else {
                                dispatch(mergeapprovedSeries({ data: quickLoad?.approvedSeries }))
                            }
                        }
                        if (quickLoad?.approvedSeriesId) {
                            dispatch(setSelectedapprovedSeries(quickLoad?.approvedSeriesId))
                        }
                        if (quickLoad?.processedMedia) {
                            if (processedMedia_list?.length)
                                dispatch(mergeprocessedMedia({ data: quickLoad?.processedMedia }))
                            else {
                                dispatch(mergeprocessedMedia({ data: quickLoad?.processedMedia }))
                            }
                        }
                        if (quickLoad?.processedMediaId) {
                            dispatch(setSelectedprocessedMedia({ data: quickLoad?.processedMediaId }))
                        }
                        if (quickLoad?.coherentScreen) {
                            if (coherentScreen_list?.length)
                                dispatch(mergecoherentScreen({ data: quickLoad?.coherentScreen }))
                            else {
                                dispatch(mergecoherentScreen({ data: quickLoad?.coherentScreen }))
                            }
                        }
                        if (quickLoad?.coherentScreenId) {
                            dispatch(setSelectedcoherentScreen(quickLoad?.coherentScreenId))
                        }

                        if (quickLoad?.cachedUrls) {
                            firebaseapp.MergeCachedUrls(quickLoad?.cachedUrls);
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                setCacheLoaded(true);
                (window as any).cachedHasLoaded = true;
            }
            const currentUrl = window.location.href;
            Promise.resolve().then(async () => {
                let customerSetting: CustomerSettings | null = null;
                let a = dispatch(get_current_coherent_screen({
                    userId: claims.user,
                    domain: hasSubdomain(currentUrl) ? extractSubdomain(currentUrl) : null,
                }))
                let b = dispatch(fetch_customer_settings_for_domain({
                    userId: claims.user,
                    domain: extractSubdomain(currentUrl),
                    callback: (success, res) => {
                        if (success) {
                            if (res.data.length) {
                                customerSetting = res.data[0];
                            }
                        }
                    }
                }));

                await dispatch(fetch_ui_cache({
                    user: '',
                    callback: async (data, res) => {
                        if (res?.data) {
                            let jso = JSON.parse(res?.data.content);
                            window.initialState = jso;
                            await b;
                            if (customerSetting?.coherentScreen) {
                                window.initialState.coherentScreenId = customerSetting.coherentScreen
                            }
                            handle(jso);
                        }
                        setCacheLoaded(true);
                        (window as any).cachedHasLoaded = true;
                    }
                }))

            })
            console.log(currentUrl);
            if (!hasSubdomain(currentUrl)) {
                handle('');
            }
        }
    }, [claims?.user]);
    useEffect(() => {
        if ((window as any)?.cachedHasLoaded) {
            setCacheLoaded(true);
        }
    }, [(window as any)?.cachedHasLoaded]);
    useEffect(() => {
        if (coherentScreen?.id && claims?.user) {
            dispatch(get_curated_media_list_for_user({
                userId: claims?.user,
                coherentScreenId: coherentScreen?.id
            }));
        }
    }, [claims?.user, coherentScreen?.id])
    return (
        <>
            {cacheLoaded ? props.children : <div style={{ backgroundColor: 'black', height: '100vh', width: '100vw', position: 'static', top: 0, left: 0, zIndex: 1000000 }}>
                <WaitingComponent width={'70vw'} height={'70vh'} />
            </div>}
        </>
    )
}

export function extractSubdomain(url: string): string | null {
    let domain = getCurrentDomainWithoutSubdomain();
    const pattern = new RegExp(`^https?:\/\/([a-zA-Z0-9-]+)\\.${domain}`);
    const match = url.match(pattern);
    return match ? match[1] : null;
}

export function hasSubdomain(url: string): boolean {
    const pattern = /^https?:\/\/([a-zA-Z0-9-]+)\..+/;
    return pattern.test(url);
}
export function getCurrentDomainWithoutSubdomain() {
    const currentUrl = window.location.hostname;
    const domainParts = currentUrl.split(".");

    // Check if there's a subdomain, and return the domain without it
    if (domainParts.length > 2) {
        return domainParts.slice(-2).join(".");
    }

    // If there's no subdomain, just return the current domain
    return currentUrl;
}
